import {useLang} from "../context/LanguageContext";
import {useNavigate} from "react-router-dom";

const SubscriptionCard = (props) => {
    const { t } = useLang();
    const navigate = useNavigate();
    const {sub, showBuy} = props;

    return (
        <div
            className="bg-[#27ae60] text-[#000] border-2 border-[#2ecc71] rounded-[10px]"
        >
            <img
                src={sub.headerImg}
                alt={`${sub.title} top`}
                className="w-full h-20 object-fil rounded-[10px]"
            />
            <div className="px-4">
                <h2 className="text-lg font-bold mb-2 text-white">
                    {sub.title}

                    {sub.subtitle &&
                        <span className="text-red-600">&nbsp; {sub.subtitle}</span>
                    }

                    {!showBuy &&
                        <span className="text-sm font-semibold text-white"> - {sub.price}</span>
                    }
                </h2>

                <p className="font-semibold mb-1 text-white">{t('subs.description')}</p>
                <ul className="list-disc list-inside mb-2 text-sm text-white">
                    {sub.facilities.map((facility, fidx) => (
                        <li key={fidx}>{facility}</li>
                    ))}
                </ul>

                {showBuy &&
                    <p className="text-sm font-semibold mb-3 text-white">{sub.price}</p>
                }
                {showBuy &&
                    <button
                        onClick={() => navigate(`/buySubscription/${sub.id}`)}
                        className="bg-[#34495e] text-white font-bold py-2 px-4 rounded"
                    >
                        {t('btn.purchase')}
                    </button>
                }
            </div>
            {/*{showBuy &&*/}
            {/*    <img*/}
            {/*        src={sub.footerImg}*/}
            {/*        alt={`${sub.title} bottom`}*/}
            {/*        className="w-full h-[60px] object-cover rounded-t-none rounded-[10px]"*/}
            {/*    />*/}
            {/*}*/}
        </div>
    )
}

export default SubscriptionCard;